import { Component, inject, OnInit, ChangeDetectorRef } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Swal from 'sweetalert2';

import { PedidosService, Pedido } from '../../../core/services/pedidos.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './assinaturas.html',
  styleUrl: './assinaturas.css',
})
export class Assinaturas implements OnInit {
  private api = inject(PedidosService);
  private cdr = inject(ChangeDetectorRef);

  pedidos: Pedido[] = [];
  busca = '';
  erro = '';
  sucesso = '';
  carregando = true;
  processando: number | null = null;

  get filtrados(): Pedido[] {
    const q = this.busca.toLowerCase();

    return this.pedidos.filter((p) =>
      [p.codigoReferencia, p.compradorNome, p.usuarioNome, p.statusPagamento].some((v) =>
        String(v || '')
          .toLowerCase()
          .includes(q),
      ),
    );
  }

  ngOnInit(): void {
    this.carregar();
  }

  carregar(): void {
    this.carregando = true;
    this.erro = '';

    this.cdr.detectChanges();

    this.api.listar().subscribe({
      next: (pedidos) => {
        this.pedidos = pedidos;
        this.carregando = false;

        this.cdr.detectChanges();
      },

      error: (error) => {
        console.error('Erro ao carregar assinaturas:', error);

        this.carregando = false;
        this.cdr.detectChanges();

        Swal.fire({
          icon: 'error',
          title: 'Erro ao carregar',
          text: 'Não foi possível carregar os pedidos. Tente novamente.',
          confirmButtonText: 'Entendi',
          confirmButtonColor: '#064F82',
        });
      },
    });
  }

  async cancelar(p: Pedido): Promise<void> {
    if (this.processando !== null) return;

    const confirmacao = await Swal.fire({
      icon: 'warning',
      title: 'Cancelar assinatura?',
      html: `
        <p>Deseja solicitar o reembolso e inativar
        o usuário vinculado ao pedido?</p>
        <strong>${this.escaparHtml(p.codigoReferencia)}</strong>
        <p style="margin-top: 12px; color: #dc2626;">
          Esta ação pode afetar o acesso do usuário.
        </p>
      `,
      showCancelButton: true,
      confirmButtonText: 'Sim, cancelar assinatura',
      cancelButtonText: 'Voltar',
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#64748b',
      reverseButtons: true,
      focusCancel: true,
    });

    if (!confirmacao.isConfirmed) return;

    this.processando = p.id;
    this.erro = '';
    this.sucesso = '';

    this.cdr.detectChanges();

    Swal.fire({
      title: 'Processando cancelamento',
      text: 'Estamos processando a solicitação de reembolso.',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    this.api.cancelar(p.id).subscribe({
      next: (resultado) => {
        this.processando = null;
        this.cdr.detectChanges();

        Swal.fire({
          icon: 'success',
          title: 'Solicitação processada!',
          text: resultado.mensagem || 'A solicitação de cancelamento foi processada.',
          confirmButtonText: 'OK',
          confirmButtonColor: '#064F82',
        });

        this.carregar();
      },

      error: (error) => {
        console.error('Erro ao cancelar assinatura:', error);

        this.processando = null;
        this.cdr.detectChanges();

        const mensagem =
          error.error?.message ||
          error.error?.mensagem ||
          'Não foi possível cancelar a assinatura. Verifique o status do reembolso no Asaas antes de tentar novamente.';

        Swal.fire({
          icon: 'error',
          title: 'Erro no cancelamento',
          text: mensagem,
          confirmButtonText: 'Entendi',
          confirmButtonColor: '#064F82',
        });
      },
    });
  }

  private escaparHtml(valor: unknown): string {
    return String(valor ?? '').replace(/[&<>"']/g, (caractere) => {
      const entidades: Record<string, string> = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      };

      return entidades[caractere];
    });
  }
}
